import { PaymentValidationType, paymentValidationNames } from "../../store/slices/paymentPageSlice";
import commonNetwork from "../api/commonNetwork";
import paymentApi from "../api/paymentApi";
import { PaymentPageTypes } from "../types/PaymentTypes";




export const paymentHelpers = {
    getPaymentPageType(url: string): PaymentPageTypes {

        if (url.indexOf("odeme-sayfasi") != -1) {
            return "portal"
        } else if (url.indexOf("paymentpage") != -1) {
            return "paymentLink"
        } else if (url.indexOf("apipayment") != -1) {
            return "apiPage"
        } else if (url.indexOf("uyeliksiz-odeme") != -1) {
            return "publicPayment"
        } else if (url.indexOf("link-odeme") != -1) {
            return "unexpiredLink"
        }
        return "portal"
    },
    isFirmInfoVisible(paymentPage: PaymentPageTypes) {

        return paymentPage == "apiPage" || paymentPage == "paymentLink" || paymentPage == "publicPayment" || paymentPage == "unexpiredLink";
    },
    isCustomerSelectVisible(paymentPage: PaymentPageTypes) {

        return paymentPage == "publicPayment" || paymentPage == "portal" || paymentPage == "unexpiredLink";
    },
    isPaymentAmountTypeVisible(paymentPage: PaymentPageTypes) {

        return paymentPage == "portal";
    },
    isPaymentAmountAreaVisible(paymentPage: PaymentPageTypes) {

        return paymentPage != "publicPayment";
    },
    isPaymentProviderAreaVisible(paymentPage: PaymentPageTypes) {

        return paymentPage == "portal";
    },
    isHeaderNavVisible(paymentPage: PaymentPageTypes) {

        return paymentPage !== "portal";
    },

}

export const getCustomerBalance = async (customerId: number) => {
    const params = {
        customerid: customerId
    }
    const result = await commonNetwork.get("/mobile/checkbalance-v1", params);

    if (result.isSuccess && result.data != null && (result.errorMessage == null || result.errorMessage == "")) {
        return {
            data: parseFloat(result.data.toString().replace(",",".")).toFixed(2),
            isSuccess:true
        };
        // return parseFloat(result.data.returnResult.replace(",",".")).toFixed(2);
    } else {
        return {
            data: result.errorMessage,
            isSuccess:false
        };
    }
}

export const getCustomerBalanceMemo = async (customerId: number) => {
    const params = {
        customerid: customerId
    }
    const result = await commonNetwork.get("/mobile/checkbalance-v1", params);

    if (result.isSuccess && result.data) {
        return {
            data: parseFloat(result.data.toString().replace(",",".")).toFixed(2),
            isSuccess:true
        };
        // return parseFloat(result.data.returnResult.replace(",",".")).toFixed(2);
    } else {
        return {
            data: result.errorMessage,
            isSuccess:false
        };
    }
}
export function isAmountValid(paymentAmount: string) {
    const amount = paymentAmount ? paymentAmount.toString().replaceAll(",", '').replaceAll(".", '') : "0";
    return parseInt(amount) > 0;
}
export function removeAmountDots(paymentAmount: string) {
    const amount = paymentAmount ? paymentAmount.toString().replaceAll(",", '').replaceAll(".", '') : "0";
    return amount;
}
export function isInputValidationError(name: paymentValidationNames, errors: Array<PaymentValidationType>) {

    var index = errors.findIndex((element) => element.name == name);
    return index != -1;

}


export function amountToDecimal(amount: string) {

    let result = "0";
    if (parseInt(amount) > 0) {

        var last2 = amount.slice(-2);
        var first = amount.substring(0, amount.length - 2);
        result = first + "." + last2;
    }
    return result;
}
export const selectPaymentLinkInformations = async (linkHash?: string) => {


    const { data, errorMessage, isSuccess } = await commonNetwork.get("/paymentlink/" + linkHash);

    let result = {
        isSuccess: true,
        errorMessage: "",
        paymentInfo: {},
        amount: "",
        firmInfo: {},
        currencyIsoCode: "",
        customerInfo: {},
        licenseInfo: {},
        linkStatus: "",
        invoiceInfo:{},
        sendTypeId: 0
    }
    
    
    if (isSuccess) {

        var amount = data?.amount?.replaceAll(",", "").replaceAll(".", "") || "0";
        const customer = data.customerInformations;
        result = {
            linkStatus: data.linkStatus,
            errorMessage: "",
            isSuccess: data.linkStatus == "available",
            sendTypeId: data.sendTypeId,
            paymentInfo: {
                description: data.linkdesc,
                enableInstallments: data.installmentList,
                isAmountEditable: data.iseditamount,
                isPaymentProviderSelectable: false,
                isShowInstallmentHtmlTable: data.isShowHtmlTable,
                longDescription: data.longDescription,
                paymentProviderId: data?.vpInformations?.vpId || 0,
                initialPaymentProviderId: data?.vpInformations?.vpId || 0,
                isApplyComission: data?.isApplyComission
            },
            amount: amountToDecimal(amount),
            firmInfo: data.firmInformations,
            currencyIsoCode: data.currencyIsoCode,
            customerInfo: {
                city: customer?.city,
                address: customer?.address,
                country: customer?.country,
                customerCode: customer?.customerCode,
                customerid: customer?.customerId,
                customerName: customer?.customerName,
                district: customer?.district,
                email: customer?.email,
                phone: customer?.phone,
                taxCode: customer?.taxCode,
                taxOffice: customer?.taxOffice,
                tcCode: customer?.tcCode,
                isManuelInput: false,
            },
            licenseInfo: {
                licenseKey: data?.licenseKey,
                taxCode: data?.taxCode
            },
            invoiceInfo:data.invoiceInformations
        }

        return result;
    } else {
        result.isSuccess = false;
        result.errorMessage = errorMessage;
        result.linkStatus = "error";
        return result;
    }
}

export const selectEnExpiredPaymentLinkInformations = async (linkHash?: string) => {


    const { data, errorMessage, isSuccess } = await commonNetwork.get("/unexpiredpaymentlink/" + linkHash);

    let result = {
        isSuccess: true,
        errorMessage: "",
        paymentInfo: {},
        amount: "",
        firmInfo: {},
        customerInfo: {},
        licenseInfo: {},
        linkStatus: "",
        invoiceInfo:{}
    }

    if (isSuccess) {

        var amount = data?.amount?.replaceAll(",", "").replaceAll(".", "") || "0";
        const customer = data.customerInformations;
        result = {
            linkStatus: data.linkStatus,
            errorMessage: "",
            isSuccess: data.linkStatus == "available",
            paymentInfo: {
                description: data.linkdesc,
                enableInstallments: data.installmentList,
                isAmountEditable: data.iseditamount,
                isPaymentProviderSelectable: false,
                isShowInstallmentHtmlTable: data.isShowHtmlTable,
                longDescription: data.longDescription,
                paymentProviderId: data?.vpInformations?.vpId || 0,
                initialPaymentProviderId: data?.vpInformations?.vpId || 0,
                isApplyComission: data?.isApplyComission
            },
            amount: amountToDecimal(amount),
            firmInfo: data.firmInformations,
            customerInfo: {
                city: customer?.city,
                address: customer?.address,
                country: customer?.country,
                customerCode: customer?.customercode,
                customerid: customer?.customerId,
                customerName: customer?.customerName,
                district: customer?.district,
                email: customer?.email,
                phone: customer?.phone,
                taxCode: customer?.taxCode,
                taxOffice: customer?.taxOffice,
                tcCode: customer?.tcCode,
                isManuelInput: false,
            },
            licenseInfo: {
                licenseKey: data?.licenseKey,
                taxCode: data?.taxCode
            },
            invoiceInfo:{}
        }

        return result;
    } else {
        result.isSuccess = false;
        result.errorMessage = errorMessage;
        result.linkStatus = "error";
        return result;
    }
}


export const selectPaymentApiPageInformations = async (token: string) => {
    let result = {
        isSuccess: true,
        errorMessage: "",
        paymentInfo: {},
        amount: "",
        firmInfo: {},
        customerInfo: {},
        licenseInfo: {},
        linkStatus: "",
        invoiceInfo:{},
        invoiceNumber: "",
        apiKey: "",
        apiSecret: "",
    }

    const method = `/paymentform/get-token-value/${token || "token"}`;

    const apiInfo = {
        licenseKey: "",
        taxCode: "",
        passLicenseControl: true
    }
    const { data, errorMessage, isSuccess } = await paymentApi.get(method, null, apiInfo);


    if (isSuccess) { 
        const customer = data.customer;

        result = {
            linkStatus: data.linkStatus,
            amount: amountToDecimal(data.amount),
            invoiceNumber: data.invoiceNumber,
            customerInfo: {
                customerCode: customer?.code,
                customerName: customer?.nameSurname,
                phone: customer?.gsmNumber,
                email: customer?.email,
                taxCode: customer?.taxCode,
                isManuelInput: false,
            },
            errorMessage: "",
            firmInfo: data.firmInformations,
            isSuccess: data.linkStatus == "available",
            licenseInfo: {
                licenseKey: data.licenseKey,
                taxCode: data.taxCode
            },
            paymentInfo: {
                description: "",
                enableInstallments: [],
                firmKvkkText: data.firmKvkkText,
                isAmountEditable: data.isEditAmount,
                isPaymentProviderSelectable: data.paymentProviderSelect,
                isShowInstallmentHtmlTable: data.isShowInstallmentTable,
                logoUrl: data.logoUrl ? data.logoUrl : "https://tahsilat.elogo.com.tr/etahsilatapitest/Uploads/firm_logos/elogo-logo.svg",
                longDescription: data.longDescription,
                payButtonTitle: data.payButtonTitle,
                paymentDescriptionRequired: data.paymentDescriptionInputRequired,
                paymentDescriptionVisible: data.paymentDescriptionInputVisible,
                PaymentDescriptionIninitalValue: data.paymentDescriptionIninitalValue,
                paymentProviderId: data.paymentProvider,
                initialPaymentProviderId: data?.vpInformations?.vpId || 0,
                isApplyComission: data?.isApplyComission

            },
            invoiceInfo:{},
            apiKey: data.apiKey,
            apiSecret: data.apiSecret,
        }

    } else {
        result.isSuccess = false;
        result.errorMessage = errorMessage;
        result.linkStatus = "error";

    }
    return result;
}